'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface StatusFilterProps {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
}

const StatusFilter = ({ activeFilter, onFilterChange }: StatusFilterProps) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const filters = [
    { id: 'all', label: 'All Bookings', icon: 'QueueListIcon', count: 12 },
    { id: 'confirmed', label: 'Confirmed', icon: 'CheckCircleIcon', count: 8 },
    { id: 'pending', label: 'Pending', icon: 'ClockIcon', count: 2 },
    { id: 'waitlisted', label: 'Waitlisted', icon: 'QueueListIcon', count: 1 },
    { id: 'cancelled', label: 'Cancelled', icon: 'XCircleIcon', count: 1 },
  ];

  if (!isHydrated) {
    return (
      <div className="bg-card rounded-lg shadow-brand p-4 border border-border">
        <div className="animate-pulse flex space-x-2">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="h-10 bg-muted rounded flex-1"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg shadow-brand p-4 border border-border">
      <div className="flex flex-wrap gap-2">
        {filters.map((filter) => (
          <button
            key={filter.id}
            onClick={() => onFilterChange(filter.id)}
            className={`flex items-center space-x-2 px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200 ${
              activeFilter === filter.id
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'bg-surface text-foreground hover:bg-muted'
            }`}
          >
            <Icon name={filter.icon as any} size={18} />
            <span>{filter.label}</span>
            <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
              activeFilter === filter.id
                ? 'bg-primary-foreground/20 text-primary-foreground'
                : 'bg-muted text-muted-foreground'
            }`}>
              {filter.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default StatusFilter;